import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Phone, Calendar, MessageCircle, Accessibility, X, Type, Contrast, RotateCcw } from 'lucide-react';
import { useAccessibility } from '../../context/AccessibilityContext';

const MobileFooter = () => {
  const [showPanel, setShowPanel] = useState(false);
  const { largeFont, highContrast, toggleLargeFont, toggleHighContrast, resetAll } = useAccessibility();

  const phoneNumber = '+496432936960';
  const whatsappNumber = '4915225610097';

  return (
    <>
      {/* MOBILE FOOTER - FEST AM BODEN */}
      <nav 
        className="md:hidden"
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 9999,
          backgroundColor: '#032925',
          borderTop: '1px solid rgba(237, 214, 141, 0.3)'
        }}
      >
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)' }}>
          {/* Anrufen */}
          <a
            href={`tel:${phoneNumber}`}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '12px 0',
              color: '#edd68d',
              textDecoration: 'none'
            }}
          >
            <Phone style={{ width: 20, height: 20, marginBottom: 4 }} />
            <span style={{ fontSize: 11 }}>Anrufen</span>
          </a>

          {/* Termin */}
          <Link
            to="/termin"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '12px 0',
              color: '#edd68d',
              textDecoration: 'none'
            }}
          >
            <Calendar style={{ width: 20, height: 20, marginBottom: 4 }} />
            <span style={{ fontSize: 11 }}>Termin</span>
          </Link>

          {/* WhatsApp */}
          <a
            href={`https://wa.me/${whatsappNumber}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '12px 0',
              color: '#66f2ae',
              textDecoration: 'none'
            }}
          >
            <MessageCircle style={{ width: 20, height: 20, marginBottom: 4 }} />
            <span style={{ fontSize: 11 }}>WhatsApp</span>
          </a>

          {/* Barrierefrei */}
          <button
            onClick={() => setShowPanel(!showPanel)}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '12px 0',
              color: showPanel ? '#032925' : '#edd68d',
              backgroundColor: showPanel ? '#66f2ae' : 'transparent',
              border: 'none',
              cursor: 'pointer'
            }}
          >
            <Accessibility style={{ width: 20, height: 20, marginBottom: 4 }} />
            <span style={{ fontSize: 11 }}>Barrierefrei</span>
          </button>
        </div>
      </nav>

      {/* Barrierefreiheit Panel */}
      {showPanel && (
        <div
          className="md:hidden"
          style={{
            position: 'fixed',
            bottom: 60,
            left: 0,
            right: 0,
            zIndex: 9998,
            backgroundColor: 'white',
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            boxShadow: '0 -4px 20px rgba(0,0,0,0.2)'
          }}
        >
          {/* Header */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '12px 16px',
            backgroundColor: '#032925',
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            color: 'white'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <Accessibility style={{ width: 20, height: 20 }} />
              <span style={{ fontWeight: 600, fontSize: 14 }}>Barrierefreiheit</span>
            </div>
            <button
              onClick={() => setShowPanel(false)}
              style={{ background: 'none', border: 'none', color: 'white', cursor: 'pointer', padding: 4 }}
            >
              <X style={{ width: 20, height: 20 }} />
            </button>
          </div>

          {/* Optionen */}
          <div style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 12 }}>
            {/* Große Schrift */}
            <button
              onClick={toggleLargeFont}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                padding: 16,
                borderRadius: 12,
                border: 'none',
                cursor: 'pointer',
                backgroundColor: largeFont ? '#66f2ae' : '#f3f4f6',
                color: '#032925'
              }}
            >
              <Type style={{ width: 24, height: 24 }} />
              <span style={{ fontWeight: 500 }}>Große Schrift</span>
              {largeFont && <span style={{ marginLeft: 'auto', fontSize: 14 }}>✓ Aktiv</span>}
            </button>

            {/* Hoher Kontrast */}
            <button
              onClick={toggleHighContrast}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                padding: 16,
                borderRadius: 12,
                border: 'none',
                cursor: 'pointer',
                backgroundColor: highContrast ? '#66f2ae' : '#f3f4f6',
                color: '#032925'
              }}
            >
              <Contrast style={{ width: 24, height: 24 }} />
              <span style={{ fontWeight: 500 }}>Hoher Kontrast</span>
              {highContrast && <span style={{ marginLeft: 'auto', fontSize: 14 }}>✓ Aktiv</span>}
            </button>

            {/* Reset */}
            <button
              onClick={resetAll}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 8,
                padding: 16,
                borderRadius: 12,
                border: 'none',
                cursor: 'pointer',
                backgroundColor: '#fee2e2',
                color: '#dc2626'
              }}
            >
              <RotateCcw style={{ width: 20, height: 20 }} />
              <span style={{ fontWeight: 500 }}>Reset</span>
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default MobileFooter;
